<template>
  <v-dialog v-model="show" max-width="600" overlay-color="darktext" :persistent="true" data-testid="dialog" scrollable
    ref="dialog">
    <v-card elevation="0" class="pa-5">
      <AlertMessages v-if="alertValue" :alert-type="alertType" :alert-msg="alertMsg" @reset="alertValue = false" />
      <v-card-title class="pa-0">
        <v-row no-gutters>
          <v-col cols="12">
            <p class="text-h6 font-weight-bold no-break">
              {{ $t("updatedTermsTitle") }}
            </p>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text style="max-height: 350px" ref="content" class="pa-0">
        <v-row no-gutters class="fill-height">
          <v-col cols="12" class="d-flex flex-column" v-html="$t('updatedTermsTextV3')">
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-center flex-wrap mt-5">
        <v-btn ref="cancel" data-testid="cancel-button" color="darktext" min-width="100" elevation="0"
          class="rounded-xxl text-none px-4 mb-2 mb-md-0 white--text" :disabled="loading" @click="logout">
          {{ $t('logMeOut') }}
        </v-btn>
        <v-btn ref="submit" data-testid="submit-button" color="accent" min-width="100" elevation="0"
          class="rounded-xxl text-none px-4 mb-2 mb-md-0 white--text" :disabled="loading" @click="acceptTerms">
          {{ $t('approve') }}
        </v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from "./../plugins/i18n";
import AlertMessages from "./AlertMessages";
import { repeatedMethodsMixin } from "../mixins/repeatedMethodsMixin";
import { logoutAuth } from '../auth/auth.js'
import { logoutUser, updateUser } from '../api/userApi'

export default {
  components: {
    AlertMessages,
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      alertMsg: "",
      alertType: "",
      alertValue: false,
      loading: false
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    visible() {
      return this.$store.state.lockNotAcceptedTerms ? this.$store.state.lockNotAcceptedTerms : false;
    },
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    async logout() {
      this.loading = true
      try {
        const response = await logoutUser()
        if (response.status == 200) {
          logoutAuth()
          this.$router.push({ path: '/login' })
        }
      } catch (e) {
        this.alertValue = true
        this.alertType = 'error'
        this.alertMsg = i18n.t('serverError')
      }
      this.loading = false
    },
    async acceptTerms() {
      this.loading = true
      try {
        let data = {
          data: {
            type: "users",
            id: window.$cookies.get('id'),
            attributes: {
              accepted_gdpr: true,
            }
          }
        };
        const response = await updateUser(window.$cookies.get('id'), data)
        if (response.status == 200) {
          this.reloadPage()
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true
          this.alertType = 'error'
          this.alertMsg = i18n.t('serverError')
        }
      }
      this.loading = false
    },
    reloadPage(){
      window.location.reload()
    }
  },
};
</script>
